import {
  DEFAULT_SEASON_MOVEMENT,
  DIVISION_IDS_PYRAMID_BOTTOM_TO_TOP,
  DIVISIONS,
} from '@multirx/shared/types/division.js';
import type { Division } from '@multirx/shared/types/division.js';
import { fetchDivisions, seedDivisions } from './api.js';
import { createPageShell } from '../ui/pageShell.js';
import { el, btn } from '../ui/dom.js';

export function mountDivisionsApp(root: HTMLElement): void {
  root.innerHTML = '';
  root.className = 'app-view circuits-app';

  const { page, body } = createPageShell({
    title: 'Divisions',
    subtitle: `Pyramide D4 → D1. En fin de saison : ${DEFAULT_SEASON_MOVEMENT.promotedPerSeason} promotions et ${DEFAULT_SEASON_MOVEMENT.relegatedPerSeason} relégations par division (hors extrêmes).`,
    breadcrumbs: [{ label: 'Saisons', href: '#saisons' }, { label: 'Divisions' }],
  });

  const seedCard = el('div', { class: 'card' });
  const seedStatus = el('span', { class: 'page-subtitle' });
  seedStatus.style.marginLeft = '0.75rem';
  const seedBtn = btn('Peupler la base (circuits + pilotes)', { variant: 'primary' }, () => {
    seedStatus.textContent = 'Génération en cours…';
    seedBtn.disabled = true;
    seedDivisions()
      .then((r) => {
        seedStatus.textContent = r.message;
        loadList();
      })
      .catch((err) => {
        seedStatus.textContent = err instanceof Error ? err.message : 'Erreur';
      })
      .finally(() => {
        seedBtn.disabled = false;
      });
  });
  const seedRow = el('div', { class: 'page-actions' });
  seedRow.appendChild(seedBtn);
  seedRow.appendChild(seedStatus);
  seedCard.appendChild(seedRow);
  body.appendChild(seedCard);

  const pyramidSection = el('section', {
    class: 'league-pyramid',
    'aria-label': 'Pyramide des divisions',
  });
  pyramidSection.appendChild(
    el('h2', { class: 'hub-card-title', text: 'Pyramide (sommet = élite)' })
  );
  const orderTopToBottom = [...DIVISION_IDS_PYRAMID_BOTTOM_TO_TOP].reverse();
  orderTopToBottom.forEach((id, idx) => {
    const div = DIVISIONS.find((d) => d.id === id);
    if (!div) return;
    const tier = el('div', { class: `league-tier league-tier--${div.id}` });
    const row = el('div', { class: 'page-header-row' });
    const left = el('div');
    left.appendChild(
      el('span', { class: `badge badge-division--${div.id}`, text: div.shortLabel })
    );
    left.appendChild(document.createTextNode(' '));
    left.appendChild(el('strong', { text: div.name }));
    row.appendChild(left);
    row.appendChild(
      el('span', {
        class: 'page-subtitle',
        text: `${div.powerMin}–${div.powerMax}★ (indicatif)`,
      })
    );
    tier.appendChild(row);
    pyramidSection.appendChild(tier);
    if (idx < orderTopToBottom.length - 1) {
      pyramidSection.appendChild(
        el('p', { class: 'page-subtitle', text: '↓ vers division inférieure (relégation)' })
      );
    }
  });
  body.appendChild(pyramidSection);

  const listContainer = el('div', { class: 'card-grid' });
  body.appendChild(listContainer);

  function loadList(): void {
    listContainer.innerHTML = '';
    const loading = el('p', { class: 'empty-state', text: 'Chargement…' });
    listContainer.appendChild(loading);
    fetchDivisions()
      .then((divisions) => {
        listContainer.innerHTML = '';
        divisions.forEach((div: Division) => {
          const wrap = el('div', { class: 'card-glow-wrap' });
          const card = el('a', {
            class: 'card-glow',
            href: `#saisons?division=${div.id}`,
          });
          card.appendChild(el('p', { class: 'heading', text: `${div.shortLabel} — ${div.name}` }));
          card.appendChild(
            el('p', {
              text: `Fourchette ${div.powerMin}–${div.powerMax}★ · Rang ${div.pyramidRank}/4`,
            })
          );
          card.appendChild(el('p', { text: 'Classement →' }));
          card.addEventListener('click', (e) => {
            e.preventDefault();
            window.location.hash = `classement?division=${div.id}`;
          });
          wrap.appendChild(card);
          listContainer.appendChild(wrap);
        });
      })
      .catch((err) => {
        listContainer.innerHTML = '';
        listContainer.appendChild(
          el('p', { class: 'empty-state', text: err instanceof Error ? err.message : 'Erreur' })
        );
      });
  }

  loadList();
  root.appendChild(page);
}
